export default __webpack_public_path__ + "static/media/home-decor-img-20.220d2fa6.jpg";